import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Categories from "../../shared/categories/categories"

const ResourceCategories = ({ hideOnMobile, hideOnDesktop }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityResourceCategory {
        nodes {
          id
          title
          slug {
            current
          }
        }
      }
      allSanityResource {
        group(field: tabs___content___category___id) {
          totalCount
          fieldValue
        }
      }
    }
  `)

  const categories = data.allSanityResourceCategory
  const totals = data.allSanityResource.group

  return (
    <Categories
      categories={categories}
      totals={totals}
      hideOnMobile={hideOnMobile}
      hideOnDesktop={hideOnDesktop}
      allLink="/resources"
      name="resources"
    />
  )
}

export default ResourceCategories
